export const addSkill = (data) => {
    return {
        type: "ADD_SKILL",
        skill: data
    }
}

export const addUser = (data) => {
    return {
        type: "ADD_USER",
        user: data
    }
}


export const addNotifications = (data) => {
    return {
        type: "ADD_NOTIFICATIONS",
        notifications: data
    }
}

export const addNotificationsCount = (data) => {
    return {
        type: "ADD_NOTIFICATIONS_COUNT",
        notificationsCount: data
    }
}

export const addCourses = (data) => {
    return {
        type: "ADD_COURSES",
        courses: data
    }
}